module.exports = "<svg viewBox=\"0 0 40 31\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14.6801 31L0 10.5174L14.6801 20.5925L40 0L14.6801 31Z\" fill=\"#30C161\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./~/svg-inline-loader!./client/components/SuccessScreen/check_green.svg
// module id = 663
// module chunks = 0